import { logStatsigEvent } from './statsigConfiguration';

const enum DeserializeFlowEventType {
  DeserializeHotelWithOldIngredientPrefix = 'deserialize_hotel_with_old_ingredient_prefix',
  DeserializeHotelWithoutHotelFiltersPrefix = 'deserialize_hotel_without_hotel_filters_prefix',
  DeserializeHotelWithoutSuggestionOrderPrefix = 'deserialize_hotel_without_suggestion_order_prefix',
  DeserializeHotelWithOldRoomPrefix = 'deserialize_hotel_with_old_room_prefix',
  DeserializeHotelWithoutBoardBasisPrefix = 'deserialize_hotel_without_board_basis_prefix',
  DeserializeHotelWithoutRoomTypeId = 'deserialize_hotel_without_room_type_id',
  DeserializeHotelWithOldRoomPropPrefix = 'deserialize_hotel_with_old_room_prop_prefix',
  DeserializeStayWithoutSelectionPrefix = 'deserialize_stay_without_selection_prefix',
  DeserializeTransportWithoutSuggestionOrderPrefix = 'deserialize_transport_without_suggestion_order_prefix',
  DeserializeActivityWithSupplierToken = 'deserialize_activity_with_supplier_token',
}

interface UrlMetadata extends Record<string, string> {
  url: string;
  referrer: string;
}

export function getUrlMetadata(): UrlMetadata {
  return {
    url: window.location.href,
    referrer: document.referrer,
  };
}

export function trackDeserializeHotelWithOldIngredientPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldIngredientPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutHotelFiltersPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutHotelFiltersPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithOldRoomPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldRoomPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutBoardBasisPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutBoardBasisPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithoutRoomTypeId(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithoutRoomTypeId,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeHotelWithOldRoomPropPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeHotelWithOldRoomPropPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeStayWithoutSelectionPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeStayWithoutSelectionPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeTransportWithoutSuggestionOrderPrefix(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeTransportWithoutSuggestionOrderPrefix,
    undefined,
    getUrlMetadata()
  );
}

export function trackDeserializeActivityWithSupplierToken(): void {
  logStatsigEvent(
    DeserializeFlowEventType.DeserializeActivityWithSupplierToken,
    undefined,
    getUrlMetadata()
  );
}

export function trackFallbackStaticInfoReceived(metadata: {
  searchTerm?: string[];
  hotelTypes?: string[];
  searchType: string;
}): void {
  logStatsigEvent('telemetry_fallback_static_info_received', undefined, {
    searchTerm: metadata.searchTerm?.join(',') ?? '',
    hotelTypes: metadata.hotelTypes?.join(',') ?? '',
    searchType: metadata.searchType,
  });
}
